const globalBanner = {
  statusOpen: "Open",
  statusClose: "Close",
  statusFailed: "Failed",
  statusSuccess: "Success",
};

export default globalBanner;
